module.exports = __webpack_public_path__ + "static/ana-65379f4b38a3c776ee88d3a19e4151b7.jpg";